import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { ArrowLongLeftIcon } from "@heroicons/react/24/solid";
import { ButtonBase } from "../index.tsx";
import { Fragment } from "react";

interface ISliderWrapperProps {
  isOpen: boolean;
  handleCloseModal: () => void;
  isLoading?: boolean;
  title?: string;
  description?: string;
  containerClass?: string;
  children: React.ReactNode;
  isChanged?: boolean;
}

function SliderWrapper({
  isOpen,
  handleCloseModal,
  isLoading,
  title,
  description,
  containerClass,
  children,
}: ISliderWrapperProps) {
  return (
    <Transition as={Fragment} appear show={isOpen}>
      <Dialog as="div" onClose={() => {}}>
        <TransitionChild
          as={Fragment}
          enter="ease-out transform duration-300"
          enterFrom="opacity-0 "
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-50 bg-black/50" />
        </TransitionChild>
        <div className="fixed inset-0 overflow-y-auto z-50 overflow-x-hidden ">
          <TransitionChild
            as={Fragment}
            enter="ease-out transform duration-300"
            enterFrom="opacity-0 translate-x-32"
            enterTo="opacity-100 translate-x-0"
          >
            <div className="flex h-screen items-center justify-center p-4">
              <DialogPanel
                className={`fixed top-0 right-0 h-screen bg-white p-6 
                 flex flex-col gap-4 rounded-l-2xl shadow-xl ${containerClass}`}
              >
                <section
                  className="flex flex-col items-start border-b
                 border-extraLightGray pb-2"
                >
                  <ButtonBase
                    className="text-secondary flex-row-reverse gap-2 mb-3"
                    icon={<ArrowLongLeftIcon className="size-5" />}
                    text="Back to page"
                    buttonType="tertiary"
                    onClick={handleCloseModal}
                  />
                  <h1 className="tw-heading">{title}</h1>
                  <p className="tw-sub-heading">{description}</p>
                </section>
                {isLoading ? (
                  <div className="h-56 bg-lightGray rounded-lg animate-pulse" />
                ) : (
                  children
                )}
              </DialogPanel>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}

export default SliderWrapper;
